import { Card, Link, Loading, SkeletonBodyText } from "@shopify/polaris";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { CarbonSectionType } from "../../types/CarbonSectionType";
import { PortalState } from "../../types/PortalState";
import styles from "./CarbonSection.module.css";
import CarbonSectionInput from "./CarbonSectionInput";
import { useSelector } from "react-redux";
import {
    CarbonSectionInputData
} from "../../types/CarbonSection";

const MAPS_URL =
    "https://www.google.com/search?q=google%20maps%20directions&hl=en&authuser=0&ei=dmrhYaveIpOM8gKQmp6QCw%3A3&ved=1t%3A40399";

const CALCULATOR_URL = "https://www.greatcirclemapper.net/";

export default function CarbonSection(): ReactElement {
    const { t } = useTranslation("common");

    const currentInspection = useSelector(
        (state: PortalState) => state.portal.activeInspection
    );

    return (
        <>
            {currentInspection ?
                <section>
                    <article className={styles.about}>
                        <p className="normal-text">{t("inspection.carbon.about_1")}</p>
                        <div className={styles.space}></div>
                        <p className="normal-text">{t("inspection.carbon.about_2")}</p>
                    </article>

                    <CarbonSectionInput
                        type={CarbonSectionType.CAR}
                        data={
                            currentInspection.CarbonSectionData.CarSection
                                ? currentInspection.CarbonSectionData.CarSection
                                : ({} as CarbonSectionInputData)
                        }
                        description={
                            <p>
                                {t("inspection.carbon.car_distance_help")}{" "}
                                <Link onClick={() => { window.open(MAPS_URL, "_blank"); }}>
                                    {t("inspection.carbon.google_maps")}
                                </Link>{" "}
                                {t("inspection.carbon.car_distance_help_2")}
                            </p>
                        }
                        title={t("inspection.carbon.car")}
                        inputLabel={
                            t("inspection.carbon.input_label") +
                            t("inspection.carbon.car").toLowerCase()
                        }
                    />

                    <CarbonSectionInput
                        type={CarbonSectionType.AEROPLANE}
                        data={
                            currentInspection.CarbonSectionData.AeroplaneSection
                                ? currentInspection.CarbonSectionData.AeroplaneSection
                                : ({} as CarbonSectionInputData)
                        }
                        description={
                            <p>
                                {t("inspection.carbon.aeroplane_distance_help")}{" "}
                                <Link onClick={() => { window.open(CALCULATOR_URL, "_blank"); }} external>{CALCULATOR_URL}</Link>
                            </p>
                        }
                        title={t("inspection.carbon.aeroplane")}
                        inputLabel={
                            t("inspection.carbon.input_label") +
                            t("inspection.carbon.aeroplane").toLowerCase()
                        }
                    />

                    <CarbonSectionInput
                        type={CarbonSectionType.TRAIN}
                        data={
                            currentInspection.CarbonSectionData.TrainSection
                                ? currentInspection.CarbonSectionData.TrainSection
                                : ({} as CarbonSectionInputData)
                        }
                        description={
                            <p>
                                {t("inspection.carbon.train_distance_help")}{" "}
                                <Link onClick={() => { window.open(MAPS_URL, "_blank"); }}>
                                    {t("inspection.carbon.google_maps")}
                                </Link>{" "}
                                {t("inspection.carbon.train_distance_help_2")}
                            </p>
                        }
                        title={t("inspection.carbon.train")}
                        inputLabel={
                            t("inspection.carbon.input_label") +
                            t("inspection.carbon.train").toLowerCase()
                        }
                    />
                </section>
                : <div>
                    <Loading />
                    <Card sectioned>
                        <SkeletonBodyText />
                    </Card>
                    <Card sectioned>
                        <SkeletonBodyText />
                    </Card>
                </div>}
        </>
    );
}
